import operationTypes from 'constants/operationTypes';
import { Operation, Partner, Society } from 'types';
import {
  getPartnerOperationsFromType,
  OperationType,
} from 'utils/getPartnerOperationsFromType';

export const getPartnerIncorporationDate = async (
  society: Society,
  partner: Partner
) => {
  if (!society || !partner) return null;

  if (partner?.incorporationDate) {
    return partner.incorporationDate;
  }

  try {
    const validOps: OperationType[] = [
      operationTypes.CONSTITUTION,
      operationTypes.CAPITAL_INCREASE,
      operationTypes.SELL_PARTICIPATION,
      operationTypes.HERITAGE,
      operationTypes.DONATION,
      operationTypes.ENDORSEMENT,
      operationTypes.TRANSMISSION,
    ];

    const partnerOperations = (await getPartnerOperationsFromType({
      partner,
      society,
      operationType: validOps,
    })) as Operation[];

    if (partnerOperations.length === 0) {
      return null;
    }

    const firstPartnerOperation = partnerOperations.reduce((acc, operation) => {
      if (!acc) return operation;
      return new Date(operation.date) < new Date(acc.date) ? operation : acc;
    }, partnerOperations[0]);

    return firstPartnerOperation.date || null;
  } catch {
    return null;
  }
};
